<template>
  <div class="container-fluid" style="-webkit-print-color-adjust: exact">
    <div class="previewPrint">
      <div class="row">
        <div class="col">
          <compiled-report-table-components :compiledData="compiledReportPrint" :is-print="true"></compiled-report-table-components>
        </div>
      </div>
      <div class="row" style="font-size: 0.9rem !important;">
        <div class="col-12">
        <span>十年心血管風險對照
          <spans class="d-inline-block m-1" style="width: 18px; height: 18px; background-color: #58A707;
                transform: translate(0px, 7px);"></spans>
           低度風險
          <spans class="d-inline-block m-1" style="width: 18px; height: 18px; background-color: #FFE247;
                transform: translate(0px, 7px);"></spans>
           中度風險
          <spans class="d-inline-block m-1" style="width: 18px; height: 18px; background-color: #CF772F;
                transform: translate(0px, 7px);"></spans>
           高度風險
          <spans class="d-inline-block m-1" style="width: 18px; height: 18px; background-color: #E30000;
                 transform: translate(0px, 7px);"></spans>
           極高風險
        </span>
        </div>
        <div class="col-12">
        <span>異常工作促發風險對照
          <spans class="d-inline-block m-1" style="width: 18px; height: 18px; background-color: #58A707;
                 transform: translate(0px, 7px);"></spans>
           0:低度風險
          <spans class="d-inline-block m-1" style="width: 18px; height: 18px; background-color: #FFE247;
                 transform: translate(0px, 7px);"></spans>
           1或2:中度風險
          <spans class="d-inline-block m-1" style="width: 18px; height: 18px; background-color: #CF772F;
                transform: translate(0px, 7px);"></spans>
           3或4:高度風險
        </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import CompiledReportTableComponents from '@/components/OccupationalService/CompiledReportTableComponents.vue';

const { mapGetters: mapPatientGetters } = createNamespacedHelpers('patient');

export default {
  name: 'CompiledReport',
  components: {
    CompiledReportTableComponents,
  },
  mounted() {
    setTimeout(function() {
      window.print();
    }, 2000);
  },
  computed: {
    ...mapPatientGetters({ compiledReportPrint: 'compiledReportPrint' }),
  },
};
</script>

<style scoped src="../../assets/print.css"></style>
